import { gql, type TypedDocumentNode } from "@apollo/client";

export type EmailPreview = {
  subject: string;
  html: string;
};

export interface CanceledEventRegistrationEmailPreviewQueryResponse {
  canceledEventRegistrationEmailPreview: EmailPreview;
}

export interface CanceledEventRegistrationEmailPreviewQueryVariables {
  registrationId: string;
}

export interface TransferredEventRegistrationEmailPreviewInput {
  sourceRegistrationId: string;
  targetEventId: string;
  targetSessionIds?: string[] | null;
}

export interface TransferredEventRegistrationEmailPreviewQueryResponse {
  transferredEventRegistrationEmailPreview: EmailPreview;
}

export interface TransferredEventRegistrationEmailPreviewQueryVariables {
  input: TransferredEventRegistrationEmailPreviewInput;
}

export interface PromotedFromWaitlistEmailPreviewQueryResponse {
  promotedFromWaitlistEmailPreview: EmailPreview;
}

export interface PromotedFromWaitlistEmailPreviewQueryVariables {
  eventId: string;
  personId: string;
}

export const CANCELED_EVENT_REGISTRATION_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  CanceledEventRegistrationEmailPreviewQueryResponse,
  CanceledEventRegistrationEmailPreviewQueryVariables
> = gql`
  query CanceledEventRegistrationEmailPreview($registrationId: ID!) {
    canceledEventRegistrationEmailPreview(registrationId: $registrationId) {
      subject
      html
    }
  }
`;

export const TRANSFERRED_EVENT_REGISTRATION_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  TransferredEventRegistrationEmailPreviewQueryResponse,
  TransferredEventRegistrationEmailPreviewQueryVariables
> = gql`
  query TransferredEventRegistrationEmailPreview($input: BackofficeEventsTransferEventRegistrationInput!) {
    transferredEventRegistrationEmailPreview(input: $input) {
      subject
      html
    }
  }
`;

export const PROMOTED_FROM_WAITLIST_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  PromotedFromWaitlistEmailPreviewQueryResponse,
  PromotedFromWaitlistEmailPreviewQueryVariables
> = gql`
  query PromotedFromWaitlistEmailPreview($eventId: ID!, $personId: ID!) {
    promotedFromWaitlistEmailPreview(eventId: $eventId, personId: $personId) {
      subject
      html
    }
  }
`;

export interface CanceledEventEmailPreviewQueryResponse {
  canceledEventEmailPreview: EmailPreview;
}

export interface CanceledEventEmailPreviewQueryVariables {
  eventId: string;
}

export interface EventSessionUpdatedEmailPreviewInput {
  sessionId: string;
  oldStartsAt: string;
  newStartsAt?: string | null;
  newEndsAt?: string | null;
}

export interface EventSessionUpdatedEmailPreviewQueryResponse {
  eventSessionUpdatedEmailPreview: EmailPreview;
}

export interface EventSessionUpdatedEmailPreviewQueryVariables {
  input: EventSessionUpdatedEmailPreviewInput;
}

export interface RecruitmentEventCreationEmailPreviewInput {
  eventId?: string | null;
  eventTitle?: string | null;
}

export interface RecruitmentEventCreationEmailPreviewQueryResponse {
  recruitmentEventCreationEmailPreview: EmailPreview;
}

export interface RecruitmentEventCreationEmailPreviewQueryVariables {
  input: RecruitmentEventCreationEmailPreviewInput;
}

export interface RecruitmentEventFinalizeRecapEmailPreviewQueryResponse {
  recruitmentEventFinalizeRecapEmailPreview: EmailPreview;
}

export interface RecruitmentEventFinalizeRecapEmailPreviewQueryVariables {
  eventId: string;
}

export interface PatFinalizedScoresEmailPreviewQueryResponse {
  patFinalizedScoresEmailPreview: EmailPreview;
}

export interface PatFinalizedScoresEmailPreviewQueryVariables {
  eventId: string;
}

export const CANCELED_EVENT_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  CanceledEventEmailPreviewQueryResponse,
  CanceledEventEmailPreviewQueryVariables
> = gql`
  query CanceledEventEmailPreview($eventId: ID!) {
    canceledEventEmailPreview(eventId: $eventId) {
      subject
      html
    }
  }
`;

export const EVENT_SESSION_UPDATED_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  EventSessionUpdatedEmailPreviewQueryResponse,
  EventSessionUpdatedEmailPreviewQueryVariables
> = gql`
  query EventSessionUpdatedEmailPreview($input: BackofficeEventsEventSessionUpdatedEmailPreviewInput!) {
    eventSessionUpdatedEmailPreview(input: $input) {
      subject
      html
    }
  }
`;

export const RECRUITMENT_EVENT_CREATION_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  RecruitmentEventCreationEmailPreviewQueryResponse,
  RecruitmentEventCreationEmailPreviewQueryVariables
> = gql`
  query RecruitmentEventCreationEmailPreview($input: BackofficeEventsRecruitmentEventCreationEmailPreviewInput!) {
    recruitmentEventCreationEmailPreview(input: $input) {
      subject
      html
    }
  }
`;

export const RECRUITMENT_EVENT_FINALIZE_RECAP_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  RecruitmentEventFinalizeRecapEmailPreviewQueryResponse,
  RecruitmentEventFinalizeRecapEmailPreviewQueryVariables
> = gql`
  query RecruitmentEventFinalizeRecapEmailPreview($eventId: ID!) {
    recruitmentEventFinalizeRecapEmailPreview(eventId: $eventId) {
      subject
      html
    }
  }
`;

export const PAT_FINALIZED_SCORES_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  PatFinalizedScoresEmailPreviewQueryResponse,
  PatFinalizedScoresEmailPreviewQueryVariables
> = gql`
  query PatFinalizedScoresEmailPreview($eventId: ID!) {
    patFinalizedScoresEmailPreview(eventId: $eventId) {
      subject
      html
    }
  }
`;
